var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("view-page", {
    attrs: {
      title: _vm.pageTitle,
      loading: _vm.loading,
      "delete-dialog-title": _vm.$t("DeleteComment"),
      "delete-dialog-content": _vm.deleteMessage,
      "delete-button": _vm.userCanDeleteComment,
      "edit-button": _vm.userCanDeleteComment,
      "permission-name": _vm.permissionName
    },
    on: { deleteItem: _vm.deleteComment, editItem: _vm.editComment },
    scopedSlots: _vm._u([
      {
        key: "leftSide",
        fn: function() {
          return _vm._l(_vm.fields, function(field) {
            return _c("view-page-data-field", {
              key: field.template,
              attrs: { icon: field.icon, label: field.label, data: field.data }
            })
          })
        },
        proxy: true
      },
      {
        key: "headerRightSide",
        fn: function() {
          return [
            _c(
              "div",
              [
                _c("management-tabs-and-search", {
                  attrs: { tabs: _vm.tabs, "open-tab": _vm.openTab },
                  on: {
                    "update-open-tab": function($event) {
                      _vm.openTab = $event
                    }
                  }
                }),
                _vm._v(" "),
                _vm.openTab === "attachments"
                  ? _c("management-add-button", {
                      attrs: {
                        label: _vm.$t("AddAttachment"),
                        disabled: false,
                        "list-missing-permissions": []
                      },
                      on: { buttonClick: _vm.openAttachmentForm }
                    })
                  : _vm._e()
              ],
              1
            )
          ]
        },
        proxy: true
      },
      {
        key: "rightSide",
        fn: function() {
          return [
            _vm.comment
              ? _c(
                  "v-tabs-items",
                  { attrs: { value: _vm.openTab } },
                  [
                    _c(
                      "v-tab-item",
                      {
                        staticClass: "elevation-2",
                        attrs: { value: "description" }
                      },
                      [
                        _c("textarea", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.comment.text,
                              expression: "comment.text"
                            }
                          ],
                          staticClass: "input-field",
                          staticStyle: { height: "382px" },
                          attrs: { id: "description", readonly: "" },
                          domProps: { value: _vm.comment.text },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(_vm.comment, "text", $event.target.value)
                            }
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "v-tab-item",
                      { attrs: { value: "attachments" } },
                      [
                        _c("attachments-table", {
                          attrs: { attachments: _vm.comment.attachments },
                          on: {
                            "open-attachment": function($event) {
                              return _vm.openAttachment($event)
                            },
                            "reload-comment": _vm.getComment
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c("attachment-form", {
              attrs: { open: _vm.attachmentForm.isOpen },
              on: {
                "add-attachment": function($event) {
                  return _vm.saveAttachment($event)
                },
                close: _vm.closeAttachmentForm
              }
            })
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6f18d50c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6f18d50c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Support/TechnicalSupport/TicketCommentDetails.vue
// module id = null
// module chunks = 